import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guard/auth.guard';
import { HomeComponent } from './dashboard/components/home/home.component';
import { AppLobbyComponent } from './dashboard/components/app-lobby/app-lobby.component';
import { UnauthorizedComponent } from './dashboard/components/unauthorized/unauthorized.component';
import { appPermissionGuard } from './auth/guard/app-permission.guard';
import { StudySavedComponent } from 'projects/enclave-studies/src/app/components/studies/study-saved/study-saved.component';
import { AnalyticsServicesSaved } from 'projects/enclave-config/src/app/components/config/analytics-services-saved/analytics-services-saved.component';
import { Oauth2CallbackComponent } from './auth/oauth2-callback/oauth2-callback.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [appPermissionGuard],
        children: [
          {
            path: '',
            component: AppLobbyComponent
          },
          {
            path: 'config',
            loadChildren: () => import('../../projects/enclave-config/src/app/app.module').then(m => m.AppModule),
          },
          {
            path: 'inbox',
            loadChildren: () => import('../../projects/enclave-inbox/src/app/app.module').then(m => m.AppModule),
          },
          {
            path: 'budget',
            loadChildren: () => import('../../projects/enclave-budget/src/app/app.module').then(m => m.AppModule),
            data: {
              breadcrumb: 'Budget'
            }
          },
           {
            path: 'studies',
            loadChildren: () => import('../../projects/enclave-studies/src/app/app.module').then(m => m.AppModule),
            data: {
              breadcrumb: 'Studies'
            }
          },
          {
            path: 'studies/:id',
            loadChildren: () => import('../../projects/enclave-studies/src/app/app.module').then(m => m.AppModule),
          },
          {
            path: 'catalogue',
            loadChildren: () => import('../../projects/enclave-data-catalogue/src/app/app.module').then(m => m.AppModule),
            data: {
              breadcrumb: 'Data'
            }
          },
        ]
      },
      {
        path: 'auth/callback',
        component: Oauth2CallbackComponent
      },
      {
        path: 'study-saved',
        component: StudySavedComponent
      }, 
      {
        path: 'analytics-services-saved',
        component: AnalyticsServicesSaved
      },
       {
        path: 'u',
        component: UnauthorizedComponent,
      },
      {
        path: 'u1',
        component: UnauthorizedComponent,
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
